
export const selectUser = state => state.currentUser.user;
export const selectUserID = state => state.currentUser.userID;
export const selectToken = state => state.currentUser.token;